import { configureStore } from "@reduxjs/toolkit";
import axios from "axios";
import qs from 'qs';


const initialState = {
  searchResults: null,
  searchParams: {
    vehicleType: "",
    brand: "",
    model: "",
    year: "",
    // Add all advanced filters to the initial state for clean access
    colorSelect: "",
    carDriveType: "",
    carEngine: "",
    carFilterAccessories: [],
    carFuelType: "",
    carMileage: "",
    carPrice: "",
    carSeat: "",
    carSteering: "",
    carTransmission: "",
  },

  //Cart
  cart: {
    items: [],
    totalItems: 0,
    loading: false,
    error: null,
  },

  //Brand
  cars: {
    items: [],
    loading: false,
    error: null,
    selectedBrand: null,
  },

  //Model Name
  modelNameCars: {
    itemsByModel: {},
    loading: false,
    error: null,
    currentModel: null,
    totalItems: 0,
    totalPages: 0
  },

  //Body Type
  bodyTypeCars: {
    items: [],
    loading: false,
    error: null,
    selectedBodyType: null,
  },

  //Car Usage
  carUsage: {
    items: [],
    loading: false,
    error: null,
    selectedUsageFilter: null,
  },

  //price Usage
  carPrice: {
    items: [],
    loading: false,
    error: null,
    selectedPriceFilter: null,
  },

  //carMileage
  carMileage: {
    items: [],
    loading: false,
    error: null,
    selectedMileageFilter: null,
  },

  //carEngine
  carEngine: {
    items: [],
    loading: false,
    error: null,
    selectedEngineFilter: null,
  },

  //carOtherSpecs
  carOtherSpecs: {
    items: [],
    loading: false,
    error: null,
    selectedSpecType: null,
    selectedSpecValue: null,
  },

  // carColor
  carColor: {
    items: [],
    loading: false,
    error: null,
    selectedColorFilter: null,
  },

  // allCarModels
  allCarModels: {
    items: [],
    loading: false,
    error: null,
  },

  //WishList
  wishlist: {
    items: [],
    totalItems: 0,
    loading: false,
    error: null,
  },

  //profile image
  profileImage: {
    url: null,
    loading: false,
    error: null,
  },

  //pagination
  items: [],
  totalItems: 0,
  totalPages: 0,
  loading: false,
  error: null,
};



//Adavnced Filter
const SEARCH_REQUEST = 'SEARCH_REQUEST';
const SEARCH_SUCCESS = 'SEARCH_SUCCESS';
const SEARCH_FAILURE = 'SEARCH_FAILURE';

// Add new action types for body type
const FETCH_CARS_BY_BODY_TYPE_REQUEST = "FETCH_CARS_BY_BODY_TYPE_REQUEST";
const FETCH_CARS_BY_BODY_TYPE_SUCCESS = "FETCH_CARS_BY_BODY_TYPE_SUCCESS";
const FETCH_CARS_BY_BODY_TYPE_FAILURE = "FETCH_CARS_BY_BODY_TYPE_FAILURE";

// Action Types for Model Name
const FETCH_CARS_BY_MODEL_NAME_REQUEST = "FETCH_CARS_BY_MODEL_NAME_REQUEST";
const FETCH_CARS_BY_MODEL_NAME_SUCCESS = "FETCH_CARS_BY_MODEL_NAME_SUCCESS";
const FETCH_CARS_BY_MODEL_NAME_FAILURE = "FETCH_CARS_BY_MODEL_NAME_FAILURE";

// Action Types for brand
const SET_SELECTED_BRAND = "SET_SELECTED_BRAND";
const FETCH_CARS_BY_BRAND_REQUEST = "FETCH_CARS_BY_BRAND_REQUEST";
const FETCH_CARS_BY_BRAND_SUCCESS = "FETCH_CARS_BY_BRAND_SUCCESS";
const FETCH_CARS_BY_BRAND_FAILURE = "FETCH_CARS_BY_BRAND_FAILURE";

//Car Usage Action Types
const FETCH_CAR_USAGE_REQUEST = "FETCH_CAR_USAGE_REQUEST";
const FETCH_CAR_USAGE_SUCCESS = "FETCH_CAR_USAGE_SUCCESS";
const FETCH_CAR_USAGE_FAILURE = "FETCH_CAR_USAGE_FAILURE";

// Add Price-related Action Types
const FETCH_CARS_BY_PRICE_REQUEST = "FETCH_CARS_BY_PRICE_REQUEST";
const FETCH_CARS_BY_PRICE_SUCCESS = "FETCH_CARS_BY_PRICE_SUCCESS";
const FETCH_CARS_BY_PRICE_FAILURE = "FETCH_CARS_BY_PRICE_FAILURE";

// Add new action types for car mileage
const FETCH_CARS_BY_MILEAGE_REQUEST = "FETCH_CARS_BY_MILEAGE_REQUEST";
const FETCH_CARS_BY_MILEAGE_SUCCESS = "FETCH_CARS_BY_MILEAGE_SUCCESS";
const FETCH_CARS_BY_MILEAGE_FAILURE = "FETCH_CARS_BY_MILEAGE_FAILURE";

// Add new action types for car ENGINE
const FETCH_CARS_BY_ENGINE_REQUEST = "FETCH_CARS_BY_ENGINE_REQUEST";
const FETCH_CARS_BY_ENGINE_SUCCESS = "FETCH_CARS_BY_ENGINE_SUCCESS";
const FETCH_CARS_BY_ENGINE_FAILURE = "FETCH_CARS_BY_ENGINE_FAILURE";

// Add new action types for car OTHER_SPECS
const FETCH_CARS_BY_OTHER_SPECS_REQUEST = "FETCH_CARS_BY_OTHER_SPECS_REQUEST";
const FETCH_CARS_BY_OTHER_SPECS_SUCCESS = "FETCH_CARS_BY_OTHER_SPECS_SUCCESS";
const FETCH_CARS_BY_OTHER_SPECS_FAILURE = "FETCH_CARS_BY_OTHER_SPECS_FAILURE";

// Add new action types for car color
const FETCH_CARS_BY_COLOR_REQUEST = "FETCH_CARS_BY_COLOR_REQUEST";
const FETCH_CARS_BY_COLOR_SUCCESS = "FETCH_CARS_BY_COLOR_SUCCESS";
const FETCH_CARS_BY_COLOR_FAILURE = "FETCH_CARS_BY_COLOR_FAILURE";

// Action Types
const SET_SEARCH_RESULTS = "SET_SEARCH_RESULTS";
const SET_SEARCH_PARAMS = "SET_SEARCH_PARAMS";
const CART_REQUEST = "CART_REQUEST";
const CART_SUCCESS = "CART_SUCCESS";
const CART_FAILURE = "CART_FAILURE";
const ADD_TO_CART_REQUEST = "ADD_TO_CART_REQUEST";
const ADD_TO_CART_SUCCESS = "ADD_TO_CART_SUCCESS";
const ADD_TO_CART_FAILURE = "ADD_TO_CART_FAILURE";

// Add new action types for all car models
const FETCH_ALL_CAR_MODELS_REQUEST = "FETCH_ALL_CAR_MODELS_REQUEST";
const FETCH_ALL_CAR_MODELS_SUCCESS = "FETCH_ALL_CAR_MODELS_SUCCESS";
const FETCH_ALL_CAR_MODELS_FAILURE = "FETCH_ALL_CAR_MODELS_FAILURE";

// Add new action types for wishlist
const WISHLIST_REQUEST = "WISHLIST_REQUEST";
const WISHLIST_SUCCESS = "WISHLIST_SUCCESS";
const WISHLIST_FAILURE = "WISHLIST_FAILURE";
const ADD_TO_WISHLIST_REQUEST = "ADD_TO_WISHLIST_REQUEST";
const ADD_TO_WISHLIST_SUCCESS = "ADD_TO_WISHLIST_SUCCESS";
const ADD_TO_WISHLIST_FAILURE = "ADD_TO_WISHLIST_FAILURE";
const REMOVE_FROM_WISHLIST_REQUEST = "REMOVE_FROM_WISHLIST_REQUEST";
const REMOVE_FROM_WISHLIST_SUCCESS = "REMOVE_FROM_WISHLIST_SUCCESS";
const REMOVE_FROM_WISHLIST_FAILURE = "REMOVE_FROM_WISHLIST_FAILURE";

//Remove From Cart
const REMOVE_FROM_CART_REQUEST = "REMOVE_FROM_CART_REQUEST";
const REMOVE_FROM_CART_SUCCESS = "REMOVE_FROM_CART_SUCCESS";
const REMOVE_FROM_CART_FAILURE = "REMOVE_FROM_CART_FAILURE";

//Move Cart TO Wishlist
const MOVE_TO_WISHLIST_FROM_CART_REQUEST = "MOVE_TO_WISHLIST_FROM_CART_REQUEST";
const MOVE_TO_WISHLIST_FROM_CART_SUCCESS = "MOVE_TO_WISHLIST_FROM_CART_SUCCESS";
const MOVE_TO_WISHLIST_FROM_CART_FAILURE = "MOVE_TO_WISHLIST_FROM_CART_FAILURE";

const CLEAR_CART = "CLEAR_CART";
const CLEAR_WISHLIST = "CLEAR_WISHLIST";

//Profile Image
const SET_PROFILE_IMAGE = "SET_PROFILE_IMAGE";
const PROFILE_IMAGE_LOADING = "PROFILE_IMAGE_LOADING";
const PROFILE_IMAGE_ERROR = "PROFILE_IMAGE_ERROR";

function appReducer(state = initialState, action) {
  switch (action.type) {

    // Advanced Filter cases
    case SEARCH_REQUEST:
      return { ...state, loading: true, error: null };
    case SEARCH_SUCCESS:
      return {
        ...state,
        loading: false,
        // searchResults will be updated by SET_SEARCH_RESULTS
      };
    case SEARCH_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // Existing search cases
    case SET_SEARCH_RESULTS:
      return {
        ...state,
        searchResults: action.payload.data,
        totalItems: action.payload.totalItems,
        totalPages: action.payload.totalPages,
      };
    case SET_SEARCH_PARAMS:
      // FIX: Removed updating totalItems/totalPages from SET_SEARCH_PARAMS
      return {
        ...state,
        searchParams: action.payload,
      };

    //  search for brand
    case SET_SELECTED_BRAND:
      return {
        ...state,
        cars: {
          ...state.cars,
          selectedBrand: action.payload,
        },
      };

    // New cart cases
    case CART_REQUEST:
      return {
        ...state,
        cart: {
          ...state.cart,
          loading: true,
          error: null,
        },
      };
    case CART_SUCCESS:
      return {
        ...state,
        cart: {
          items: action.payload.items || [],
          totalItems: action.payload.totalItems || 0,
          loading: false,
          error: null,
        },
      };
    case CART_FAILURE:
      return {
        ...state,
        cart: {
          ...state.cart,
          loading: false,
          error: action.payload,
        },
      };
    case ADD_TO_CART_REQUEST:
      return {
        ...state,
        cart: {
          ...state.cart,
          loading: true,
          error: null,
        },
      };
    case ADD_TO_CART_SUCCESS:
      return {
        ...state,
        cart: {
          ...state.cart,
          loading: false,
          error: null,
        },
      };
    case ADD_TO_CART_FAILURE:
      return {
        ...state,
        cart: {
          ...state.cart,
          loading: false,
          error: action.payload,
        },
      };

    // Remove From Cart
    case REMOVE_FROM_CART_REQUEST:
      return {
        ...state,
        cart: {
          ...state.cart,
          loading: true,
          error: null,
        },
      };
    case REMOVE_FROM_CART_SUCCESS:
      return {
        ...state,
        cart: {
          ...state.cart,
          loading: false,
          error: null,
        },
      };
    case REMOVE_FROM_CART_FAILURE:
      return {
        ...state,
        cart: {
          ...state.cart,
          loading: false,
          error: action.payload,
        },
      };

    // Move To Wishlist From Cart
    case MOVE_TO_WISHLIST_FROM_CART_REQUEST:
      return {
        ...state,
        cart: {
          ...state.cart,
          loading: true,
          error: null,
        },
      };
    case MOVE_TO_WISHLIST_FROM_CART_SUCCESS:
      return {
        ...state,
        cart: {
          ...state.cart,
          loading: false,
          error: null,
        },
      };
    case MOVE_TO_WISHLIST_FROM_CART_FAILURE:
      return {
        ...state,
        cart: {
          ...state.cart,
          loading: false,
          error: action.payload,
        },
      };

    // Body Type Cases
    case FETCH_CARS_BY_BODY_TYPE_REQUEST:
      return {
        ...state,
        bodyTypeCars: {
          ...state.bodyTypeCars,
          loading: true,
          error: null,
        },
      };
    case FETCH_CARS_BY_BODY_TYPE_SUCCESS:
      return {
        ...state,
        bodyTypeCars: {
          ...state.bodyTypeCars,
          items: action.payload,
          loading: false,
          error: null,
          totalItems: action.payload.totalItems,
          totalPages: action.payload.totalPages,
        },
      };
    case FETCH_CARS_BY_BODY_TYPE_FAILURE:
      return {
        ...state,
        bodyTypeCars: {
          ...state.bodyTypeCars,
          items: [],
          loading: false,
          error: action.payload,
        },
      };

    // Model Name cases
    case FETCH_CARS_BY_MODEL_NAME_REQUEST:
      return {
        ...state,
        modelNameCars: {
          ...state.modelNameCars,
          loading: true,
          error: null,
          currentModel: action.payload.modelName
        },
      };
    case FETCH_CARS_BY_MODEL_NAME_SUCCESS:
      return {
        ...state,
        modelNameCars: {
          ...state.modelNameCars,
          itemsByModel: {
            ...state.modelNameCars.itemsByModel,
            [action.payload.modelName]: action.payload.data
          },
          loading: false,
          totalItems: action.payload.totalItems,
          totalPages: action.payload.totalPages
        },
      };
    case FETCH_CARS_BY_MODEL_NAME_FAILURE:
      return {
        ...state,
        modelNameCars: {
          ...state.modelNameCars,
          loading: false,
          error: action.payload,
          itemsByModel: {
            ...state.modelNameCars.itemsByModel,
            [action.meta.modelName]: []
          }
        },
      };

    // Brand Types cases
    case FETCH_CARS_BY_BRAND_REQUEST:
      return {
        ...state,
        cars: {
          ...state.cars,
          loading: true,
          error: null,
        },
      };
    case FETCH_CARS_BY_BRAND_SUCCESS:
      return {
        ...state,
        cars: {
          ...state.cars,
          items: action.payload,
          loading: false,
          error: null,
          totalItems: action.payload.totalItems,
          totalPages: action.payload.totalPages,
        },
      };
    case FETCH_CARS_BY_BRAND_FAILURE:
      return {
        ...state,
        cars: {
          ...state.cars,
          items: [],
          loading: false,
          error: action.payload,
        },
      };

    //car usage Type cases
    case FETCH_CAR_USAGE_REQUEST:
      return {
        ...state,
        carUsage: {
          ...state.carUsage,
          loading: true,
          error: null,
        },
      };
    case FETCH_CAR_USAGE_SUCCESS:
      return {
        ...state,
        carUsage: {
          ...state.carUsage,
          items: action.payload,
          loading: false,
          error: null,
          totalItems: action.payload.totalItems,
          totalPages: action.payload.totalPages,
        },
      };
    case FETCH_CAR_USAGE_FAILURE:
      return {
        ...state,
        carUsage: {
          ...state.carUsage,
          items: [],
          loading: false,
          error: action.payload,
        },
      };

    // Price-related cases
    case FETCH_CARS_BY_PRICE_REQUEST:
      return {
        ...state,
        carPrice: {
          ...state.carPrice,
          loading: true,
          error: null,
        },
      };
    case FETCH_CARS_BY_PRICE_SUCCESS:
      return {
        ...state,
        carPrice: {
          ...state.carPrice,
          items: action.payload,
          loading: false,
          error: null,
          totalItems: action.payload.totalItems,
          totalPages: action.payload.totalPages,
        },
      };
    case FETCH_CARS_BY_PRICE_FAILURE:
      return {
        ...state,
        carPrice: {
          ...state.carPrice,
          items: [],
          loading: false,
          error: action.payload,
        },
      };

    // Car Mileage-related cases
    case FETCH_CARS_BY_MILEAGE_REQUEST:
      return {
        ...state,
        carMileage: {
          ...state.carMileage,
          loading: true,
          error: null,
        },
      };
    case FETCH_CARS_BY_MILEAGE_SUCCESS:
      return {
        ...state,
        carMileage: {
          ...state.carMileage,
          items: action.payload,
          loading: false,
          error: null,
          totalItems: action.payload.totalItems,
          totalPages: action.payload.totalPages,
        },
      };
    case FETCH_CARS_BY_MILEAGE_FAILURE:
      return {
        ...state,
        carMileage: {
          ...state.carMileage,
          items: [],
          loading: false,
          error: action.payload,
        },
      };

    // Car ENGINE-related cases
    case FETCH_CARS_BY_ENGINE_REQUEST:
      return {
        ...state,
        carEngine: {
          ...state.carEngine,
          loading: true,
          error: null,
        },
      };
    case FETCH_CARS_BY_ENGINE_SUCCESS:
      return {
        ...state,
        carEngine: {
          ...state.carEngine,
          items: action.payload,
          loading: false,
          error: null,
          totalItems: action.payload.totalItems,
          totalPages: action.payload.totalPages,
        },
      };
    case FETCH_CARS_BY_ENGINE_FAILURE:
      return {
        ...state,
        carEngine: {
          ...state.carEngine,
          items: [],
          loading: false,
          error: action.payload,
        },
      };

    // Car carOtherSpecs-related cases
    case FETCH_CARS_BY_OTHER_SPECS_REQUEST:
      return {
        ...state,
        carOtherSpecs: {
          ...state.carOtherSpecs,
          loading: true,
          error: null,
        },
      };
    case FETCH_CARS_BY_OTHER_SPECS_SUCCESS:
      return {
        ...state,
        carOtherSpecs: {
          ...state.carOtherSpecs,
          items: action.payload,
          loading: false,
          error: null,
          totalItems: action.payload.totalItems,
          totalPages: action.payload.totalPages,
        },
      };
    case FETCH_CARS_BY_OTHER_SPECS_FAILURE:
      return {
        ...state,
        carOtherSpecs: {
          ...state.carOtherSpecs,
          items: [],
          loading: false,
          error: action.payload,
        },
      };

    // Car Color-related cases
    case FETCH_CARS_BY_COLOR_REQUEST:
      return {
        ...state,
        carColor: {
          ...state.carColor,
          loading: true,
          error: null,
        },
      };
    case FETCH_CARS_BY_COLOR_SUCCESS:
      return {
        ...state,
        carColor: {
          ...state.carColor,
          items: action.payload,
          loading: false,
          error: null,
          totalItems: action.payload.totalItems,
          totalPages: action.payload.totalPages,
        },
      };
    case FETCH_CARS_BY_COLOR_FAILURE:
      return {
        ...state,
        carColor: {
          ...state.carColor,
          items: [],
          loading: false,
          error: action.payload,
        },
      };

    // Car model-related cases
    case FETCH_ALL_CAR_MODELS_REQUEST:
      return {
        ...state,
        allCarModels: {
          ...state.allCarModels,
          loading: true,
          error: null,
        },
      };
    case FETCH_ALL_CAR_MODELS_SUCCESS:
      return {
        ...state,
        allCarModels: {
          ...state.allCarModels,
          items: action.payload,
          loading: false,
          error: null,
        },
      };
    case FETCH_ALL_CAR_MODELS_FAILURE:
      return {
        ...state,
        allCarModels: {
          ...state.allCarModels,
          items: [],
          loading: false,
          error: action.payload,
        },
      };

    // Wishlist cases
    case WISHLIST_SUCCESS:
      return {
        ...state,
        wishlist: {
          items: action.payload.items || [],
          totalItems: action.payload.totalItems || 0,
          loading: false,
          error: null,
        },
      };
    case WISHLIST_FAILURE:
      return {
        ...state,
        wishlist: {
          ...state.wishlist,
          loading: false,
          error: action.payload,
        },
      };
    case ADD_TO_WISHLIST_REQUEST:
      return {
        ...state,
        wishlist: {
          ...state.wishlist,
          loading: true,
          error: null,
        },
      };
    case ADD_TO_WISHLIST_SUCCESS:
      return {
        ...state,
        wishlist: {
          ...state.wishlist,
          loading: false,
          error: null,
        },
      };
    case ADD_TO_WISHLIST_FAILURE:
      return {
        ...state,
        wishlist: {
          ...state.wishlist,
          loading: false,
          error: action.payload,
        },
      };
    case REMOVE_FROM_WISHLIST_REQUEST:
      return {
        ...state,
        wishlist: {
          ...state.wishlist,
          loading: true,
          error: null,
        },
      };
    case REMOVE_FROM_WISHLIST_SUCCESS:
      return {
        ...state,
        wishlist: {
          ...state.wishlist,
          loading: false,
          error: null,
        },
      };
    case REMOVE_FROM_WISHLIST_FAILURE:
      return {
        ...state,
        wishlist: {
          ...state.wishlist,
          loading: false,
          error: action.payload,
        },
      };

    // Profile image cases
    case SET_PROFILE_IMAGE:
      return {
        ...state,
        profileImage: {
          url: action.payload,
          loading: false,
          error: null,
        },
      };
    case PROFILE_IMAGE_LOADING:
      return {
        ...state,
        profileImage: {
          ...state.profileImage,
          loading: true,
          error: null,
        },
      };
    case PROFILE_IMAGE_ERROR:
      return {
        ...state,
        profileImage: {
          ...state.profileImage,
          loading: false,
          error: action.payload,
        },
      };
    case CLEAR_CART:
      return {
        ...state,
        cart: {
          items: [],
          totalItems: 0,
          loading: false,
          error: null,
        },
      };

    case CLEAR_WISHLIST:
      return {
        ...state,
        wishlist: {
          items: [],
          totalItems: 0,
          loading: false,
          error: null,
        },
      };

    // In your reducer file
    case SET_TOTAL_ITEMS:
      return {
        ...state,
        totalItems: action.payload
      };
    case SET_TOTAL_PAGES:
      return {
        ...state,
        totalPages: action.payload
      };

    default:
      return state;
  }
}

//Action Creators for Advanced Filter
export const searchRequest = () => ({ type: SEARCH_REQUEST });
export const searchSuccess = (results) => ({ type: SEARCH_SUCCESS, payload: results });
export const searchFailure = (error) => ({ type: SEARCH_FAILURE, payload: error });

// Action Creators



// In your action types file
export const SET_TOTAL_ITEMS = 'SET_TOTAL_ITEMS';
export const SET_TOTAL_PAGES = 'SET_TOTAL_PAGES';

// In your actions file
export const setTotalItems = (totalItems) => ({
  type: SET_TOTAL_ITEMS,
  payload: totalItems
});

export const setTotalPages = (totalPages) => ({
  type: SET_TOTAL_PAGES,
  payload: totalPages
});




export const setSearchResults = (results) => ({
  type: SET_SEARCH_RESULTS,
  payload: results,
});

export const setSearchParams = (params) => ({
  type: SET_SEARCH_PARAMS,
  payload: params,
});

export const setSearchParam = (params) => ({
  type: SET_SEARCH_PARAMS,
  payload: params,
});

// Body Type Action Creators
export const fetchCarsByBodyTypeRequest = () => ({
  type: FETCH_CARS_BY_BODY_TYPE_REQUEST,
});

export const fetchCarsByBodyTypeSuccess = (cars) => ({
  type: FETCH_CARS_BY_BODY_TYPE_SUCCESS,
  payload: cars,
});

export const fetchCarsByBodyTypeFailure = (error) => ({
  type: FETCH_CARS_BY_BODY_TYPE_FAILURE,
  payload: error,
});

// Action Creators for cars
export const setSelectedBrand = (brand) => ({
  type: SET_SELECTED_BRAND,
  payload: brand,
});

// Cart Action Creators
export const fetchCartRequest = () => ({
  type: CART_REQUEST,
});

export const fetchCartSuccess = (data) => ({
  type: CART_SUCCESS,
  payload: data,
});

export const fetchCartFailure = (error) => ({
  type: CART_FAILURE,
  payload: error,
});

export const addToCartRequest = () => ({
  type: ADD_TO_CART_REQUEST,
});

export const addToCartSuccess = () => ({
  type: ADD_TO_CART_SUCCESS,
});

export const addToCartFailure = (error) => ({
  type: ADD_TO_CART_FAILURE,
  payload: error,
});

//Remove from Cart
export const removeFromCartRequest = () => ({
  type: REMOVE_FROM_CART_REQUEST,
});

export const removeFromCartSuccess = () => ({
  type: REMOVE_FROM_CART_SUCCESS,
});

export const removeFromCartFailure = () => ({
  type: REMOVE_FROM_CART_FAILURE,
});

// Move To Wishlist From Cart
export const moveToWishlistFromCartRequest = () => ({
  type: MOVE_TO_WISHLIST_FROM_CART_REQUEST,
});

export const moveToWishlistFromCartSuccess = () => ({
  type: MOVE_TO_WISHLIST_FROM_CART_SUCCESS,
});

export const moveToWishlistFromCartFailure = () => ({
  type: MOVE_TO_WISHLIST_FROM_CART_SUCCESS,
});

export const clearCart = () => ({ type: CLEAR_CART });
export const clearWishlist = () => ({ type: CLEAR_WISHLIST });

// Model Name Action Creators
export const fetchCarsByModelNameRequest = () => ({
  type: FETCH_CARS_BY_MODEL_NAME_REQUEST,
});

export const fetchCarsByModelNameSuccess = (modelName, data, totalItems, totalPages) => ({
  type: FETCH_CARS_BY_MODEL_NAME_SUCCESS,
  payload: {
    modelName,
    data,
    totalItems,
    totalPages
  }
});

export const fetchCarsByModelNameFailure = (error) => ({
  type: FETCH_CARS_BY_MODEL_NAME_FAILURE,
  payload: error,
});

// Brand Action Creators
export const fetchCarsByBrandRequest = () => ({
  type: FETCH_CARS_BY_BRAND_REQUEST,
});

export const fetchCarsByBrandSuccess = (cars) => ({
  type: FETCH_CARS_BY_BRAND_SUCCESS,
  payload: cars,
});

export const fetchCarsByBrandFailure = (error) => ({
  type: FETCH_CARS_BY_BRAND_FAILURE,
  payload: error,
});

// Car Usage Action Creators
export const fetchCarUsageRequest = () => ({
  type: FETCH_CAR_USAGE_REQUEST,
});

export const fetchCarUsageSuccess = (cars) => ({
  type: FETCH_CAR_USAGE_SUCCESS,
  payload: cars,
});

export const fetchCarUsageFailure = (error) => ({
  type: FETCH_CAR_USAGE_FAILURE,
  payload: error,
});

// Price Action Creators
export const fetchCarsByPriceRequest = () => ({
  type: FETCH_CARS_BY_PRICE_REQUEST,
});

export const fetchCarsByPriceSuccess = (cars) => ({
  type: FETCH_CARS_BY_PRICE_SUCCESS,
  payload: cars,
});

export const fetchCarsByPriceFailure = (error) => ({
  type: FETCH_CARS_BY_PRICE_FAILURE,
  payload: error,
});

// Car Mileage Action Creators
export const fetchCarsByMileageRequest = () => ({
  type: FETCH_CARS_BY_MILEAGE_REQUEST,
});

export const fetchCarsByMileageSuccess = (cars) => ({
  type: FETCH_CARS_BY_MILEAGE_SUCCESS,
  payload: cars,
});

export const fetchCarsByMileageFailure = (error) => ({
  type: FETCH_CARS_BY_MILEAGE_FAILURE,
  payload: error,
});

// Action Creators for Engine Specification
export const fetchCarsByEngineRequest = () => ({
  type: FETCH_CARS_BY_ENGINE_REQUEST,
});

export const fetchCarsByEngineSuccess = (cars) => ({
  type: FETCH_CARS_BY_ENGINE_SUCCESS,
  payload: cars,
});

export const fetchCarsByEngineFailure = (error) => ({
  type: FETCH_CARS_BY_ENGINE_FAILURE,
  payload: error,
});

// Action Creators for Other Specifications
export const fetchCarsByOtherSpecsRequest = () => ({
  type: FETCH_CARS_BY_OTHER_SPECS_REQUEST,
});

export const fetchCarsByOtherSpecsSuccess = (cars) => ({
  type: FETCH_CARS_BY_OTHER_SPECS_SUCCESS,
  payload: cars,
});

export const fetchCarsByOtherSpecsFailure = (error) => ({
  type: FETCH_CARS_BY_OTHER_SPECS_FAILURE,
  payload: error,
});

// Color Action Creators
export const fetchCarsByColorRequest = () => ({
  type: FETCH_CARS_BY_COLOR_REQUEST,
});

export const fetchCarsByColorSuccess = (cars) => ({
  type: FETCH_CARS_BY_COLOR_SUCCESS,
  payload: cars,
});

export const fetchCarsByColorFailure = (error) => ({
  type: FETCH_CARS_BY_COLOR_FAILURE,
  payload: error,
});

// Action creators car Models
export const fetchAllCarModelsRequest = () => ({
  type: FETCH_ALL_CAR_MODELS_REQUEST,
});

export const fetchAllCarModelsSuccess = (models) => ({
  type: FETCH_ALL_CAR_MODELS_SUCCESS,
  payload: models,
});

export const fetchAllCarModelsFailure = (error) => ({
  type: FETCH_ALL_CAR_MODELS_FAILURE,
  payload: error,
});

// Add wishlist action creators
export const fetchWishlistRequest = () => ({
  type: WISHLIST_REQUEST,
});

export const fetchWishlistSuccess = (data) => ({
  type: WISHLIST_SUCCESS,
  payload: data,
});

export const fetchWishlistFailure = (error) => ({
  type: WISHLIST_FAILURE,
  payload: error,
});

export const addToWishlistRequest = () => ({
  type: ADD_TO_WISHLIST_REQUEST,
});

export const addToWishlistSuccess = () => ({
  type: ADD_TO_WISHLIST_SUCCESS,
});

export const addToWishlistFailure = (error) => ({
  type: ADD_TO_WISHLIST_FAILURE,
  payload: error,
});

export const removeFromWishlistRequest = () => ({
  type: REMOVE_FROM_WISHLIST_REQUEST,
});

export const removeFromWishlistSuccess = () => ({
  type: REMOVE_FROM_WISHLIST_SUCCESS,
});

export const removeFromWishlistFailure = (error) => ({
  type: REMOVE_FROM_WISHLIST_FAILURE,
  payload: error,
});

// Thunk Actions
export const fetchCart = () => async (dispatch) => {
  dispatch(fetchCartRequest());
  try {
    const token = localStorage.getItem("authToken");
    if (!token) {
      throw new Error("No authentication token found. Please log in.");
    }

    const response = await axios.get(
      "https://car.amar.co.jp/api/master/car-cart-and-whishlist/get/items?type=ADD_IN_CART",
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (response.data.code === 200) {
      dispatch(fetchCartSuccess(response.data));
    } else {
      dispatch(fetchCartFailure(response.data.message));
    }

    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 404) {
      dispatch(fetchCartFailure("Cart is empty."));
      dispatch(fetchCartSuccess(error.response.data));
    }
    dispatch(fetchCartSuccess(error.response.data));
  }
};

//Thunk Actions for Cart
export const addToCart = (modelId) => async (dispatch) => {
  dispatch(addToCartRequest());

  try {
    const token = localStorage.getItem("authToken");

    if (!token) {
      throw new Error("Unauthorized! Please log in.");
    }

    const response = await axios.post(
      `https://car.amar.co.jp/api/master/car-cart-and-whishlist/manage/item?modelId=${modelId}&SelectType=ADD_IN_CART`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    if (response.data.code === 200) {
      dispatch(addToCartSuccess());
      dispatch(fetchCart());
      return { success: true, message: response.data.message };
    } else {
      dispatch(addToCartFailure("Unexpected response. Please try again."));
      return {
        success: false,
        message: "Unexpected response. Please try again.",
      };
    }
  } catch (error) {
    let errorMessage = "Error adding to cart";

    if (error.response) {
      // Handle specific status codes
      if (
        error.response.data &&
        error.response.data.status &&
        error.response.data.status.code === 409
      ) {
        errorMessage =
          error.response.data.message ||
          "This item already exists in your cart or wishlist.";
        // When we get a 409, it's already in cart, so we should treat this as a "success" for UI purposes
        dispatch(addToCartSuccess());
        dispatch(fetchCart());
        return { success: false, message: errorMessage, alreadyInCart: true };
      } else if (error.response.status === 401) {
        errorMessage = "Please Login First.";
      } else if (error.response.status === 500) {
        errorMessage = "Server error. Please try again later.";
      } else {
        errorMessage = error.response.data?.message || "Unknown error occurred";
      }
    }

    dispatch(addToCartFailure(errorMessage));
    return { success: false, message: errorMessage };
  }
};

//Thunk Actions for Remove From Cart
export const removeFromCart = (modelId) => async (dispatch) => {
  dispatch(removeFromCartRequest());

  try {
    const token = localStorage.getItem("authToken");

    if (!token) {
      throw new Error("Unauthorized! Please log in.");
    }

    const response = await axios.delete(
      `https://car.amar.co.jp/api/master/car-cart-and-whishlist/delete/item?Enter%20ModelId=${modelId}`,
      {
        method: "DELETE",
        headers: {
          accept: "application/json",
          "Accept-Language": "en",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (response.ok) {
      dispatch(removeFromCartSuccess());
      dispatch(fetchCart());
      return { success: true, message: response.data.message };
    } else {
      dispatch(removeFromCartFailure("Unexpected response. Please try again."));
      return {
        success: false,
        message: "Unexpected response. Please try again.",
      };
    }

  } catch (error) {
    let errorMessage = "Error adding to cart";

    if (error.response) {
      // Handle specific status codes
      if (
        error.response.data &&
        error.response.data.status &&
        error.response.data.status.code === 409
      ) {
        errorMessage =
          error.response.data.message ||
          "This item already exists in your cart or wishlist.";
        // When we get a 409, it's already in cart, so we should treat this as a "success" for UI purposes
        dispatch(removeFromCartSuccess());
        dispatch(fetchCart());
        return { success: false, message: errorMessage, alreadyInCart: true };
      } else if (error.response.status === 401) {
        errorMessage = "Please Login First.";
      } else if (error.response.status === 500) {
        errorMessage = "Server error. Please try again later.";
      } else {
        errorMessage = error.response.data?.message || "Unknown error occurred";
      }
    }

    dispatch(removeFromCartFailure(errorMessage));
    return { success: false, message: errorMessage };
  }
};

//Thunk Actions for Move To Wishlist From Cart
export const moveToWishlistFromCart = (modelId) => async (dispatch) => {
  dispatch(moveToWishlistFromCartRequest());

  try {
    const token = localStorage.getItem("authToken");

    if (!token) {
      throw new Error("Unauthorized! Please log in.");
    }

    const response = await axios.post(
      `https://car.amar.co.jp/api/master/car-cart-and-whishlist/manage/item?modelId=${modelId}&SelectType=MOVE_TO_WISHLIST`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    if (response.ok) {
      dispatch(moveToWishlistFromCartSuccess());
      dispatch(fetchCart());
      dispatch(fetchWishlist());
      return { success: true, message: response.data.message };
    } else {
      dispatch(moveToWishlistFromCartFailure("Unexpected response. Please try again."));
      return {
        success: false,
        message: "Unexpected response. Please try again.",
      };
    }

  } catch (error) {
    let errorMessage = "Error adding to cart";

    if (error.response) {
      // Handle specific status codes
      if (
        error.response.data &&
        error.response.data.status &&
        error.response.data.status.code === 409
      ) {
        errorMessage =
          error.response.data.message ||
          "This item already exists in your cart or wishlist.";
        // When we get a 409, it's already in cart, so we should treat this as a "success" for UI purposes
        dispatch(moveToWishlistFromCartSuccess());
        dispatch(fetchCart());
        dispatch(fetchWishlist());
        return { success: false, message: errorMessage, alreadyInCart: true };
      } else if (error.response.status === 401) {
        errorMessage = "Please Login First.";
      } else if (error.response.status === 500) {
        errorMessage = "Server error. Please try again later.";
      } else {
        errorMessage = error.response.data?.message || "Unknown error occurred";
      }
    }

    dispatch(moveToWishlistFromCartFailure(errorMessage));
    return { success: false, message: errorMessage };
  }
};

// FIX: Removing redundant performMoreFilter. The functionality is now in performAdvanceFilter.
// export const performMoreFilter = ( ... ) => async (dispatch) => { ... };


// Fixed performAdvanceFilter function (canonical function for all advanced filters)

export const performAdvanceFilter = (
  selectedCategory, // Object { label: 'SUV' } or string 'SUV' or null
  selectedBrand, // Object { label: 'Toyota' } or string 'Toyota' or null
  selectedModels = [], // Array of { carModelName: 'Corolla' } or array of strings
  selectedYears = [], // Array of { year: 2020 } or array of numbers
  page = 0,
  size = 10,
  colorSelect = null,
  carDriveType = null,
  carEngine = null,
  carFilterAccessories = null, // Array of accessory strings
  carFuelType = null,
  carMileage = null,
  carPrice = null,
  carSeat = null,
  carSteering = null,
  carTransmission = null,
  globalSearch = null // NEW: Global search parameter
) => async (dispatch) => {
  dispatch(searchRequest());
  try {
    const queryParams = {};

    // 1. Global Search (NEW)
    if (globalSearch && globalSearch.trim() !== '') {
      queryParams.search = globalSearch.trim();
    }

    // 2. Basic Filters (Handling Object/String/Array format)
    const categoryName = selectedCategory?.label || selectedCategory || "";
    if (categoryName) queryParams.categoryName = categoryName;

    const brandName = selectedBrand?.label || selectedBrand || "";
    if (brandName) queryParams.brandName = brandName;

    if (selectedModels?.length > 0) {
      // Map models array of objects/strings to array of strings
      queryParams.modelNames = selectedModels.map(m => m.carModelName || m);
    }

    if (selectedYears?.length > 0) {
      // Map years array of objects/numbers to array of strings/numbers
      queryParams.years = selectedYears.map(y => y.year ?? y);
    }

    // 3. Advanced Filters (Only add if they exist and are non-empty strings)
    if (colorSelect) queryParams.colorSelect = colorSelect;
    if (carDriveType) queryParams.carDriveType = carDriveType;
    if (carEngine) queryParams.carEngine = carEngine;
    if (carFuelType) queryParams.carFuelType = carFuelType;
    if (carMileage) queryParams.carMileage = carMileage;
    if (carPrice) queryParams.carPrice = carPrice;
    if (carSeat) queryParams.carSeat = carSeat;
    if (carSteering) queryParams.carSteering = carSteering;
    if (carTransmission) queryParams.carTransmission = carTransmission;

    // 4. Handle Accessories (Always expect an array of strings, ensure uppercase)
    if (carFilterAccessories) {
      const accessoriesArray = Array.isArray(carFilterAccessories) ? carFilterAccessories : [carFilterAccessories];
      queryParams.carFilterAccessories = accessoriesArray
        .filter(a => a && String(a).trim() !== "")
        .map(a => String(a).toUpperCase());
    }

    // 5. Pagination
    queryParams.page = page.toString();
    queryParams.size = size.toString();

    console.log("performAdvanceFilter API Query Params:", queryParams);

    const response = await axios.get(
      'https://car.amar.co.jp/api/dashboard/filter/advance-filter-new',
      {
        params: queryParams,
        // CRITICAL FIX: Use qs.stringify to handle array formats for modelNames, years, and accessories
        paramsSerializer: params => qs.stringify(params, {
          arrayFormat: 'repeat',
          encode: false
        }),
        headers: {
          "Accept-Language": "en",
          "Accept": "application/json",
        },
      }
    );

    const raw = response.data || {};

    // Extract data and pagination info
    const data = raw.data || raw.content || [];
    const totalItems = raw.totalItems ?? raw.pageInfo?.totalItems ?? 0;
    const totalPages = raw.totalPages ??
      raw.pageInfo?.totalPages ??
      Math.max(1, Math.ceil(totalItems / size));

    // Create the payload for SET_SEARCH_RESULTS
    const resultsPayload = {
      data,
      totalItems,
      totalPages,
      currentPage: page,
      itemsPerPage: size
    };

    // Create the payload for SET_SEARCH_PARAMS (flat strings for Redux state)
    const paramsPayload = {
      vehicleType: categoryName || "",
      brand: brandName || "",
      model: queryParams.modelNames?.join(',') || "",
      year: queryParams.years?.join(',') || "",
      colorSelect: colorSelect || "",
      carDriveType: carDriveType || "",
      carEngine: carEngine || "",
      carFilterAccessories: queryParams.carFilterAccessories || [],
      carFuelType: carFuelType || "",
      carMileage: carMileage || "",
      carPrice: carPrice || "",
      carSeat: carSeat || "",
      carSteering: carSteering || "",
      carTransmission: carTransmission || "",
      globalSearch: globalSearch || "" // NEW: Include global search in params
    };

    // Dispatch actions to update the state
    dispatch(setSearchResults(resultsPayload));
    dispatch(setTotalItems(totalItems));
    dispatch(setTotalPages(totalPages));
    dispatch(setSearchParams(paramsPayload));
    dispatch(searchSuccess(resultsPayload));

    // Return the complete payload including pagination data
    return resultsPayload;
  } catch (error) {
    console.error("Search error:", error.response?.data || error.message);
    dispatch(searchFailure(error.message));
    return { data: [], totalItems: 0, totalPages: 0, error: error.message };
  }
};

// Thunk Action for Fetching Cars by Model Name
export const fetchCarsByModelName = (modelName, page = 0, size = 20) => async (dispatch) => {
  dispatch({
    type: FETCH_CARS_BY_MODEL_NAME_REQUEST,
    payload: { modelName }
  });

  try {
    const queryParams = new URLSearchParams({
      page: page.toString(), // ✅ Convert to string
      size: size.toString()  // ✅ Convert to string
    });

    const url = `https://car.amar.co.jp/api/dashboard/global/model/search/${modelName}?${queryParams.toString()}`;

    console.log('fetchCarsByModelName API call:', {
      url,
      modelName,
      page,
      size
    });

    const response = await axios.get(url);

    if (response.status === 204) {
      dispatch(fetchCarsByModelNameSuccess(modelName, [], 0, 0));
      return { noContent: true };
    }

    dispatch(fetchCarsByModelNameSuccess(
      modelName,
      response.data.cars,
      response.data.totalItems,
      response.data.totalPages
    ));
    return response.cars;
  } catch (error) {
    dispatch({
      type: FETCH_CARS_BY_MODEL_NAME_FAILURE,
      payload: error.response?.data?.message || "Failed to fetch cars by Model Name",
      meta: { modelName }
    });
    return null;
  }
};

// Thunk Action for Fetching Cars by Body Type
export const fetchCarsByBodyType = (bodyType, page = 0, size = 20) => async (dispatch) => {
  dispatch(fetchCarsByBodyTypeRequest());

  try {
    const queryParams = new URLSearchParams();
    queryParams.append("bodyType", bodyType);
    queryParams.append("page", page.toString()); // ✅ Convert to string
    queryParams.append("size", size.toString()); // ✅ Convert to string

    console.log('fetchCarsByBodyType API call:', {
      url: `https://car.amar.co.jp/api/dashboard/product/get/models/by-body-type?${queryParams.toString()}`,
      page,
      size
    });

    const url = `https://car.amar.co.jp/api/dashboard/product/get/models/by-body-type?${queryParams.toString()}`;
    const response = await axios.get(url);

    if (response.status === 204) {
      dispatch(
        fetchCarsByBodyTypeSuccess({
          items: [],
          totalItems: 0,
          totalPages: 0,
        })
      );
      return { noContent: true };
    }

    dispatch(
      fetchCarsByBodyTypeSuccess({
        items: response.data.data,
        totalItems: response.data.totalItems,
        totalPages: response.data.totalPages,
      })
    );
    return response.data;
  } catch (error) {
    dispatch(
      fetchCarsByBodyTypeFailure(
        error.response?.data?.message || "Failed to fetch cars by body type"
      )
    );
    return null;
  }
};

// Thunk Action for Fetching Cars by Car Brand
export const fetchCarsByBrand = (brandName, page = 0, size = 20) => async (dispatch) => {
  dispatch(fetchCarsByBrandRequest());

  try {
    const queryParams = new URLSearchParams();
    queryParams.append("brandName", brandName);
    queryParams.append("page", page.toString()); // ✅ Convert to string
    queryParams.append("size", size.toString()); // ✅ Convert to string

    console.log('fetchCarsByBrand API call:', {
      url: `https://car.amar.co.jp/api/dashboard/product/get/models/by-brand-name?${queryParams.toString()}`,
      page,
      size
    });

    const url = `https://car.amar.co.jp/api/dashboard/product/get/models/by-brand-name?${queryParams.toString()}`;
    const response = await axios.get(url);

    if (response.status === 204) {
      dispatch(
        fetchCarsByBrandSuccess({ items: [], totalItems: 0, totalPages: 0 })
      );
      return { noContent: true };
    }

    dispatch(
      fetchCarsByBrandSuccess({
        items: response.data.data,
        totalItems: response.data.totalItems,
        totalPages: response.data.totalPages,
      })
    );
    return response.data;
  } catch (error) {
    dispatch(
      fetchCarsByBrandFailure(
        error.response?.data?.message || "Failed to fetch cars by brand"
      )
    );
    return null;
  }
};

// Thunk Action for Fetching Cars by Car Usage
export const fetchCarUsage = (usageFilter, page = 0, size = 20) => async (dispatch) => {
  dispatch(fetchCarUsageRequest());

  try {
    // Construct the request body dynamically with booleans
    const requestBody = {
      lessThanOneYear: usageFilter === "Less than 1 Year" ? "true" : "",
      oneToThreeYearsOld: usageFilter === "1 to 3 Years Old" ? "true" : "",
      fourToFiveYearsOld: usageFilter === "4 to 5 Years Old" ? "true" : "",
      sixToEightYearsOld: usageFilter === "6 to 8 Years Old" ? "true" : "",
      nineToTwelveYearsOld: usageFilter === "9 to 12 Years Old" ? "true" : "",
      thirteenYearsOld: usageFilter === "13 + Years Old" ? "true" : "",
      twentyFiveYearsOld: usageFilter === "25 + Years Old" ? "true" : "",
    };

    const queryParams = new URLSearchParams();
    queryParams.append("page", page.toString()); // ✅ Convert to string
    queryParams.append("size", size.toString()); // ✅ Convert to string

    console.log('fetchCarUsage API call:', {
      url: `https://car.amar.co.jp/api/master/specification/car-usage?${queryParams.toString()}`,
      requestBody,
      page,
      size
    });

    // Send request body directly, not wrapped in 'data'
    const response = await axios.post(
      `https://car.amar.co.jp/api/master/specification/car-usage?${queryParams.toString()}`,
      requestBody,
      {
        headers: {
          "Content-Type": "application/json",
          "Accept-Language": "en",
        },
      }
    );

    if (response.status === 204) {
      dispatch(
        fetchCarUsageSuccess({ items: [], totalItems: 0, totalPages: 0 })
      );
      return { noContent: true };
    }

    dispatch(
      fetchCarUsageSuccess({
        items: response.data.data,
        totalItems: response.data.totalItems,
        totalPages: response.data.totalPages,
      })
    );
    return response.data;
  } catch (error) {
    dispatch(
      fetchCarUsageFailure(
        error.response?.data?.message || "Failed to fetch cars by usage"
      )
    );
    return null;
  }
};

// Thunk Action for Fetching Cars by Price
// export const fetchCarsByPrice = (priceFilter, page = 0, size = 20) => async (dispatch) => {
//   dispatch(fetchCarsByPriceRequest());

//   try {
//     // Generate dynamic request body based on selection
//     const requestBody = {
//       underOneThousand: priceFilter === "Under US $1,000" ? "true" : "",
//       oneThousandToThreeThousand:
//         priceFilter === "US $1,001-$3,000" ? "true" : "",
//       threeThousandToFiveTousand:
//         priceFilter === "US $3,001-$5,000" ? "true" : "",
//       fiveThousandToSevenThousand:
//         priceFilter === "US $5,001-$7,000" ? "true" : "",
//       sevenThousandToTenThousand:
//         priceFilter === "US $7,001-$10,000" ? "true" : "",
//       tenThousandToFifteenThousand:
//         priceFilter === "US $10,001-$15,000" ? "true" : "",
//     };

//     // Create query params for page and size
//     const queryParams = new URLSearchParams();
//     queryParams.append("page", page.toString()); // ✅ Convert to string
//     queryParams.append("size", size.toString()); // ✅ Convert to string

//     console.log('fetchCarsByPrice API call:', {
//       url: `https://car.amar.co.jp/api/master/specification/car-price?${queryParams.toString()}`,
//       requestBody,
//       page,
//       size
//     });

//     const response = await axios.post(
//       `https://car.amar.co.jp/api/master/specification/car-price?${queryParams.toString()}`,
//       requestBody,
//       {
//         headers: {
//           "Content-Type": "application/json",
//           "Accept-Language": "en",
//         },
//       }
//     );

//     if (response.status === 204) {
//       dispatch(
//         fetchCarsByPriceSuccess({ items: [], totalItems: 0, totalPages: 0 })
//       );
//       return { noContent: true };
//     }

//     dispatch(
//       fetchCarsByPriceSuccess({
//         items: response.data.data,
//         totalItems: response.data.totalItems,
//         totalPages: response.data.totalPages,
//       })
//     );
//     return response.data;
//   } catch (error) {
//     dispatch(
//       fetchCarsByPriceFailure(
//         error.response?.data?.message || "Failed to fetch cars by price"
//       )
//     );
//     return null;
//   }
// };
export const fetchCarsByPrice = (priceFilter, page = 0, size = 20) => async (dispatch) => {
  dispatch(fetchCarsByPriceRequest());

  try {
    // const priceFieldMap = {
    //   '$0-$1000':     'range0$To1000$',
    //   '$1001-$2000':  'range1001$To2000$',
    //   '$2001-$3000':  'range2001$To3000$',
    //   '$3001-$4000':  'range3001$To4000$',
    //   '$4001-$5000':  'range4001$To5000$',
    //   '$5001-$6000':  'range5001$To6000$',
    //   '$6001-$7000':  'range6001$To7000$',
    //   '$7001-$8000':  'range7001$To8000$',
    //   '$8001-$9000':  'range8001$To9000$',
    //   '$9001-$10000': 'range9001$To10000$',
    //   '$10001_ABOVE': 'range10001$_ABOVE',
    // };
    const priceFieldMap = {
      '$0-$1000':     'range0$To1000$',
      '$1001-$2000':  'range1001$To2000$',
      '$2001-$3000':  'range2001$To3000$',
      '$3001-$4000':  'range3001$To4000$',
      '$4001-$5000':  'range4001$To5000$',
      '$5001-$6000':  'range5001$To6000$',
      '$6001_ABOVE':  'range6001$_ABOVE',   // ✅ Changed (baaki 4 lines hata do)
    };

    const fieldName = priceFieldMap[priceFilter] || priceFilter;
    const requestBody = { [fieldName]: "true" };

    const queryParams = new URLSearchParams();
    queryParams.append("page", page.toString());
    queryParams.append("size", size.toString());

    console.log('fetchCarsByPrice API call:', {
      url: `https://car.amar.co.jp/api/master/specification/car-price?${queryParams.toString()}`,
      requestBody,
      page,
      size
    });

    const response = await axios.post(
      `https://car.amar.co.jp/api/master/specification/car-price?${queryParams.toString()}`,
      requestBody,
      {
        headers: {
          "Content-Type": "application/json",
          "Accept-Language": "en",
        },
      }
    );

    if (response.status === 204) {
      dispatch(
        fetchCarsByPriceSuccess({ items: [], totalItems: 0, totalPages: 0 })
      );
      return { noContent: true };
    }

    dispatch(
      fetchCarsByPriceSuccess({
        items: response.data.data,
        totalItems: response.data.totalItems,
        totalPages: response.data.totalPages,
      })
    );
    return response.data;
  } catch (error) {
    dispatch(
      fetchCarsByPriceFailure(
        error.response?.data?.message || "Failed to fetch cars by price"
      )
    );
    return null;
  }
};

// Thunk Action for Fetching Cars by Mileage
export const fetchCarsByMileage = (mileageFilter, page = 0, size = 20) => async (dispatch) => {
  dispatch(fetchCarsByMileageRequest());

  try {
    // Generate dynamic request body based on selection
    const requestBody = {
      range0To5000: mileageFilter === "Less than 5,000" ? "true" : "",
      range5001To10000:
        mileageFilter === "5k-10k KM" ? "true" : "",
      range10001To20000:
        mileageFilter === "10k-20k KM" ? "true" : "",
      range20001To30000: mileageFilter === "20k-30k KM" ? "true" : "",
      range30001To40000:
        mileageFilter === "30k-40k KM" ? "true" : "",
      range40001To50000: mileageFilter === "40k-50k KM" ? "true" : "",
      range50001Above: mileageFilter === "50k KM AND ABOVE" ? "true" : "",

    };

    // Create query params for page and size
    const queryParams = new URLSearchParams();
    queryParams.append("page", page.toString()); // ✅ Convert to string
    queryParams.append("size", size.toString()); // ✅ Convert to string

    console.log('fetchCarsByMileage API call:', {
      url: `https://car.amar.co.jp/api/master/specification/car-mileage?${queryParams.toString()}`,
      requestBody,
      page,
      size
    });

    const response = await axios.post(
      `https://car.amar.co.jp/api/master/specification/car-mileage?${queryParams.toString()}`,
      requestBody,
      {
        headers: {
          "Content-Type": "application/json",
          "Accept-Language": "en",
        },
      }
    );

    if (response.status === 204) {
      dispatch(
        fetchCarsByMileageSuccess({ items: [], totalItems: 0, totalPages: 0 })
      );
      return { noContent: true };
    }

    dispatch(
      fetchCarsByMileageSuccess({
        items: response.data.data,
        totalItems: response.data.totalItems,
        totalPages: response.data.totalPages,
      })
    );
    return response.data;
  } catch (error) {
    dispatch(
      fetchCarsByMileageFailure(
        error.response?.data?.message || "Failed to fetch cars by mileage"
      )
    );
    return null;
  }
};

// Thunk Action for Fetching Cars by Engine Specification
// export const fetchCarsByEngine = (engineFilter, page = 0, size = 20) => async (dispatch) => {
//   dispatch(fetchCarsByEngineRequest());

//   try {
//     // Create request body with ONLY the selected filter
//     const requestBody = {
//       [engineFilter]: "true"
//     };

//     // Create query params for page and size
//     const queryParams = new URLSearchParams();
//     queryParams.append("page", page.toString()); // ✅ Convert to string
//     queryParams.append("size", size.toString()); // ✅ Convert to string

//     console.log('fetchCarsByEngine API call:', {
//       url: `https://car.amar.co.jp/api/master/specification/car-engine?${queryParams.toString()}`,
//       requestBody,
//       page,
//       size
//     });

//     const response = await axios.post(
//       `https://car.amar.co.jp/api/master/specification/car-engine?${queryParams.toString()}`,
//       requestBody,
//       {
//         headers: {
//           "Content-Type": "application/json",
//           "Accept-Language": "en",
//         },
//       }
//     );

//     if (response.status === 204) {
//       dispatch(
//         fetchCarsByEngineSuccess({ items: [], totalItems: 0, totalPages: 0 })
//       );
//       return { noContent: true };
//     }

//     dispatch(
//       fetchCarsByEngineSuccess({
//         items: response.data.data,
//         totalItems: response.data.totalItems,
//         totalPages: response.data.totalPages,
//       })
//     );
//     return response.data;
//   } catch (error) {
//     dispatch(
//       fetchCarsByEngineFailure(
//         error.response?.data?.message || "Failed to fetch cars by engine"
//       )
//     );
//     return null;
//   }
// };
export const fetchCarsByEngine = (engineFilter, page = 0, size = 20) => async (dispatch) => {
  dispatch(fetchCarsByEngineRequest());

  try {
    const engineFieldMap = {
      '0CC-500CC':     'range0ccTo500cc',
      '501CC-1000CC':  'range501ccTo1000cc',
      '1001CC-1500CC': 'range1001ccTo1500cc',
      '1501CC-2000CC': 'range1501ccTo2000cc',
      '2001CC-2500CC': 'range2001ccTo2500cc',
      '2501CC-3000CC': 'range2501ccTo3000cc',
      '3001CC_ABOVE':  'range3001cc_ABOVE',
    };

    const fieldName = engineFieldMap[engineFilter] || engineFilter;
    const requestBody = { [fieldName]: "true" };

    const queryParams = new URLSearchParams();
    queryParams.append("page", page.toString());
    queryParams.append("size", size.toString());

    console.log('fetchCarsByEngine API call:', {
      url: `https://car.amar.co.jp/api/master/specification/car-engine?${queryParams.toString()}`,
      requestBody,
      page,
      size
    });

    const response = await axios.post(
      `https://car.amar.co.jp/api/master/specification/car-engine?${queryParams.toString()}`,
      requestBody,
      {
        headers: {
          "Content-Type": "application/json",
          "Accept-Language": "en",
        },
      }
    );

    if (response.status === 204) {
      dispatch(
        fetchCarsByEngineSuccess({ items: [], totalItems: 0, totalPages: 0 })
      );
      return { noContent: true };
    }

    dispatch(
      fetchCarsByEngineSuccess({
        items: response.data.data,
        totalItems: response.data.totalItems,
        totalPages: response.data.totalPages,
      })
    );
    return response.data;
  } catch (error) {
    dispatch(
      fetchCarsByEngineFailure(
        error.response?.data?.message || "Failed to fetch cars by engine"
      )
    );
    return null;
  }
};

// Thunk Action for Fetching Cars by Other Specifications
export const fetchCarsByOtherSpecs = ({ type, value, page = 0, size = 20 }) =>
  async (dispatch) => {
    dispatch(fetchCarsByOtherSpecsRequest());

    try {
      // Create the request body with ONLY the selected spec
      const requestBody = {
        [value]: "true"
      };

      // ✅ FIX: Use the page and size parameters
      const queryParams = new URLSearchParams();
      queryParams.append("page", page.toString());
      queryParams.append("size", size.toString());

      console.log('fetchCarsByOtherSpecs API call:', {
        url: `https://car.amar.co.jp/api/master/specification/car-other-specification?${queryParams.toString()}`,
        requestBody,
        page,
        size,
        type,
        value
      }); // Debug log

      const response = await axios.post(
        `https://car.amar.co.jp/api/master/specification/car-other-specification?${queryParams.toString()}`,
        requestBody,
        {
          headers: {
            "Content-Type": "application/json",
            "Accept-Language": "en",
          },
        }
      );

      if (response.status === 204) {
        dispatch(
          fetchCarsByOtherSpecsSuccess({
            items: [],
            totalItems: 0,
            totalPages: 0,
          })
        );
        return { noContent: true };
      }

      dispatch(
        fetchCarsByOtherSpecsSuccess({
          items: response.data.data,
          totalItems: response.data.totalItems,
          totalPages: response.data.totalPages,
        })
      );
      return response.data;
    } catch (error) {
      dispatch(
        fetchCarsByOtherSpecsFailure(
          error.response?.data?.message || "Failed to fetch cars by other specs"
        )
      );
      return null;
    }
  };

// Thunk Action for Fetching Cars by Color
export const fetchCarsByColor = (colorFilter, page = 0, size = 20) => async (dispatch) => {
  dispatch(fetchCarsByColorRequest());

  try {
    // Create request body with ONLY the selected color
    const requestBody = {
      [colorFilter.toLowerCase()]: "true"
    };

    // Create query params for page and size
    const queryParams = new URLSearchParams();
    queryParams.append("page", page.toString()); // ✅ Convert to string
    queryParams.append("size", size.toString()); // ✅ Convert to string

    console.log('fetchCarsByColor API call:', {
      url: `https://car.amar.co.jp/api/master/specification/car-color?${queryParams.toString()}`,
      requestBody,
      page,
      size
    });

    const response = await axios.post(
      `https://car.amar.co.jp/api/master/specification/car-color?${queryParams.toString()}`,
      requestBody,
      {
        headers: {
          "Content-Type": "application/json",
          "Accept-Language": "en",
        },
      }
    );

    if (response.status === 204) {
      dispatch(
        fetchCarsByColorSuccess({ items: [], totalItems: 0, totalPages: 0 })
      );
      return { noContent: true };
    }

    dispatch(
      fetchCarsByColorSuccess({
        items: response.data.data,
        totalItems: response.data.totalItems,
        totalPages: response.data.totalPages,
      })
    );
    return response.data;
  } catch (error) {
    dispatch(
      fetchCarsByColorFailure(
        error.response?.data?.message || "Failed to fetch cars by color"
      )
    );
    return null;
  }
};

// Thunk action for fetching all car models
export const fetchAllCarModels = (page = 0, size = 20) => async (dispatch) => {
  dispatch(fetchAllCarModelsRequest());

  try {
    console.log('fetchAllCarModels API call:', {
      url: `https://car.amar.co.jp/api/dashboard/product/get/models/by-body-type`,
      params: { bodyType: 'suv', page, size }
    });

    // Using the new API endpoint with SUV body type
    const response = await axios.get(
      "https://car.amar.co.jp/api/dashboard/product/get/models/by-body-type",
      {
        params: {
          bodyType: "suv",
          page: page, // ✅ Use passed parameter
          size: size, // ✅ Use passed parameter
        },
        headers: {
          accept: "application/json",
          "Accept-Language": "en",
        },
      }
    );

    if (response.status === 204) {
      dispatch(
        fetchAllCarModelsSuccess({ items: [], totalItems: 0, totalPages: 0 })
      );
      return { noContent: true };
    }

    // Don't fetch images here - just return car data
    dispatch(fetchAllCarModelsSuccess(response.data.data));
    return response.data.data;
  } catch (error) {
    dispatch(
      fetchAllCarModelsFailure(
        error.response?.data?.message || "Failed to fetch all car models"
      )
    );
    return null;
  }
};

// Add wishlist thunk actions
export const fetchWishlist = () => async (dispatch) => {
  dispatch(fetchWishlistRequest());
  try {
    const token = localStorage.getItem("authToken");
    if (!token) {
      throw new Error("No authentication token found. Please log in.");
    }

    const response = await axios.get(
      "https://car.amar.co.jp/api/master/car-cart-and-whishlist/get/items?type=ADD_IN_WISHLIST",
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (response.data.code === 200) {
      dispatch(fetchWishlistSuccess(response.data));
    } else {
      dispatch(fetchWishlistFailure(response.data.message));
    }

    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 404) {
      dispatch(fetchWishlistFailure("Wishlist is empty."));
      dispatch(fetchWishlistSuccess(error.response.data));
    }
    dispatch(fetchWishlistFailure(error.message));
  }
};

// Add addToWishlist thunk actions
export const addToWishlist = (modelId) => async (dispatch) => {
  dispatch(addToWishlistRequest());

  try {
    const token = localStorage.getItem("authToken");

    if (!token) {
      throw new Error("Unauthorized! Please log in.");
    }

    const response = await axios.post(
      `https://car.amar.co.jp/api/master/car-cart-and-whishlist/manage/item?modelId=${modelId}&SelectType=ADD_IN_WISHLIST`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    if (response.data.code === 200) {
      dispatch(addToWishlistSuccess());
      dispatch(fetchWishlist());
      return { success: true, message: response.data.message };
    } else {
      dispatch(addToWishlistFailure("Unexpected response. Please try again."));
      return {
        success: false,
        message: "Unexpected response. Please try again.",
      };
    }
  } catch (error) {
    let errorMessage = "Error adding to wishlist";

    if (error.response) {
      if (
        error.response.data &&
        error.response.data.status &&
        error.response.data.status.code === 409
      ) {
        errorMessage =
          error.response.data.message ||
          "This item already exists in your wishlist.";
        dispatch(addToWishlistSuccess());
        dispatch(fetchWishlist());
        return {
          success: false,
          message: errorMessage,
          alreadyInWishlist: true,
        };
      } else if (error.response.status === 401) {
        errorMessage = "Please Login First.";
      } else if (error.response.status === 500) {
        errorMessage = "Server error. Please try again later.";
      } else {
        errorMessage = error.response.data?.message || "Unknown error occurred";
      }
    }

    dispatch(addToWishlistFailure(errorMessage));
    return { success: false, message: errorMessage };
  }
};

// Add removeFromWishlist thunk actions
export const removeFromWishlist = (modelId) => async (dispatch) => {
  dispatch(removeFromWishlistRequest());

  try {
    const token = localStorage.getItem("authToken");
    if (!token) {
      throw new Error("No authentication token found. Please log in.");
    }

    const response = await axios.delete(
      `https://car.amar.co.jp/api/master/car-cart-and-whishlist/delete/item?Enter%20ModelId=${modelId}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (response.data.code === 200) {
      dispatch(removeFromWishlistSuccess());
      dispatch(fetchWishlist()); // Refresh wishlist data
      return { success: true, message: response.data.message };
    } else {
      dispatch(removeFromWishlistFailure(response.data.message));
      return { success: false, message: response.data.message };
    }
  } catch (error) {
    dispatch(removeFromWishlistFailure(error.message));
    return { success: false, message: error.message };
  }
};

// Profile Image Action Creators
export const setProfileImage = (imageUrl) => ({
  type: SET_PROFILE_IMAGE,
  payload: imageUrl,
});

export const profileImageLoading = () => ({
  type: PROFILE_IMAGE_LOADING,
});

export const profileImageError = (error) => ({
  type: PROFILE_IMAGE_ERROR,
  payload: error,
});

export const fetchProfileImage = () => async (dispatch) => {
  dispatch(profileImageLoading());
  try {
    const token =
      localStorage.getItem("authToken") ||
      sessionStorage.getItem("authToken") ||
      localStorage.getItem("token") ||
      sessionStorage.getItem("token");
    if (!token) {
      // No need to throw error, we just won't have a profile image
      return;
    }

    // First check for cached image
    const cachedImageData = localStorage.getItem("profileImageData");
    if (cachedImageData) {
      dispatch(setProfileImage(cachedImageData));
    }

    // Try to get the latest image
    const response = await fetch(
      "https://car.amar.co.jp/api/authorization/user/get-image/",
      {
        headers: {
          accept: "application/json",
          "Accept-Language": "en",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (response.ok) {
      const blob = await response.blob();
      const imageUrl = URL.createObjectURL(blob);

      // Cache the image URL in localStorage
      localStorage.setItem("profileImageData", imageUrl);
      dispatch(setProfileImage(imageUrl));
    } else {
      // If first method fails, try alternative method
      const imageInfoResponse = await fetch(
        "https://car.amar.co.jp/api/authorization/user/get-image",
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Accept-Language": "en",
            "Content-Type": "application/json",
          },
        }
      );
      if (imageInfoResponse.ok) {
        const imageData = await imageInfoResponse.json();
        const fileName =
          imageData?.uniqueFileName ||
          imageData?.fileName ||
          imageData?.profileImage;
        if (fileName) {
          localStorage.setItem("profileImageFileName", fileName);
          const imageUrl = `https://car.amar.co.jp/api/authorization/user/get-image?fileName=${encodeURIComponent(
            fileName
          )}`;
          const response = await fetch(imageUrl, {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              "Accept-Language": "en",
            },
          });

          if (response.ok) {
            const blob = await response.blob();
            const objectUrl = URL.createObjectURL(blob);
            localStorage.setItem("profileImageData", objectUrl);
            dispatch(setProfileImage(objectUrl));
          }
        }
      }
    }
  } catch (error) {
    console.error("Error fetching profile image:", error);
    dispatch(profileImageError(error.message));
  }
};

// Configure the Redux store
export const store = configureStore({
  reducer: appReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});